import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import WelcomePage from './components/WelcomePage';
import AboutPage from "./components/AboutPage";
import DonationPage from "./components/DonationPage";
import './stylesheet.css';
import './App.css';

function App() {

  return (
    <Router>
      <Switch>
        <Route path="/" exact component={WelcomePage} />
        <Route path="/about" exact component={AboutPage} />
        <Route path="/donation/:trees" component={DonationPage}/>
        <Route path="/:trees" component={WelcomePage}/>
      </Switch>
    </Router>
  );
}

export default App;
